import { AuthProvider } from '@descope/react-sdk';
import { ErrorBoundary } from '@sentry/react';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorFallback } from '@application/cartes-ui/components/error-fallback';
import { Toaster } from '@application/cartes-ui/ui/sonner';

import { config } from '@/config';
import { TenantProvider } from '@/features/tenant/lib/tenant-context';
import { QueryProvider } from '@/orpc/query-provider';
import { router } from '@/router';

import '@/instrumentation';
import '@/global.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary
      fallback={({ resetError }) => <ErrorFallback onReset={resetError} />}
    >
      <AuthProvider
        projectId={config.descopeProjectId}
        baseUrl={config.descopeBaseUrl}
        autoRefresh={config.descopeAutoRefresh}
      >
        <QueryProvider>
          <TenantProvider>
            <RouterProvider router={router} />
            <Toaster richColors theme="dark" />
          </TenantProvider>
        </QueryProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
